"use client";

import { useQuery } from "@tanstack/react-query";

import { fetchSubscriptionDiscount } from "@/services/subscription-discount";

import { queryKeys } from "./query-key";

export const useSubscriptionDiscount = (enabled?: boolean) => {
  return useQuery({
    queryKey: queryKeys.subscriptionDiscount,
    queryFn: () => fetchSubscriptionDiscount(),
    enabled,
  });
};
